(function ($) {

  "use strict";

  function DestinationsPage () {
    let thisDestinationsPage = this;
    let destinationSelector = '.js-destination-page';
    let destinationSidebarSelector = '.js-destination-sidebar';
    let destinationModalTriggers = '.js-iw';
    
    this.toggleActiveLocation = function (activeElement) {
      let id = activeElement.toLowerCase();
      let $allDestinationSidebars = $(destinationSidebarSelector);
      let $active = $(destinationSidebarSelector + '[data-destination-id="' + id + '"]');

      $allDestinationSidebars.not($active).hide();
      $active.show();
      thisDestinationsPage.bindDestinationModals();
    };

    this.bindDestinationModals = function () {
      let $trigger = $(destinationModalTriggers);
      $trigger.unbind('click');
      $trigger.on('click', function () {
        let $clickedBtn = $(this);
        let $modal = $('#destinationModal');
        let id = $clickedBtn.text();
        $modal.modal('show');
        $($('select.js-partenza-item', $modal)[0]).val(id).trigger('change');
      });
    };

    let init = function (parentElement) {
      let $destinationPage = $(destinationSelector, parentElement);

      if ($destinationPage.length) {
        thisDestinationsPage.bindDestinationModals();
      }
    };

    this.init = function (element) {
      let parentElement = element ? element : $('body');
      init(parentElement);
    };
  }

  window.DestinationsPage = new DestinationsPage();

})(jQuery);
